import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import CaseFillInTheBlanksCardMultipleChoice from 'components/case_card/case_fill_in_the_blanks_card_multiple_choice';
import SentenceTranslateCard from 'components/vocab_card/sentence_translate_card';
import { CaseFillInTheBlanksCardWrapper } from '@seedlang/hoc';
import { AppUI } from '@seedlang/state';

@observer
class CaseFillInTheBlanksCard extends React.Component {

  @computed get showTextEntryCard() {
    return AppUI.user.textInputCaseTrainer;
  }

  render() {
    if (AppUI.userIsLoaded) {
      if (this.showTextEntryCard) {
        return (
          <SentenceTranslateCard
            blockEvaluateVocabOnKeystroke
            {...this.props}
          />
        );
      } else {
        return (
          <CaseFillInTheBlanksCardMultipleChoice
            {...this.props}
          />
        );
      }
    }
    return <span />;
  }
}

export default ErrorBoundary(CaseFillInTheBlanksCardWrapper(CaseFillInTheBlanksCard));